/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Les_Start_Api_Errors_No_Leerlingen_Found_For_LesInputs */

const nl_les_start_api_errors_no_leerlingen_found_for_les = /** @type {(inputs: Les_Start_Api_Errors_No_Leerlingen_Found_For_LesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze klas heeft geen leerlingen voor dit schooljaar. Kies een andere klas of voeg eerst leerlingen toe.`)
};

/**

* @param {Les_Start_Api_Errors_No_Leerlingen_Found_For_LesInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const les_start_api_errors_no_leerlingen_found_for_les = /** @type {((inputs?: Les_Start_Api_Errors_No_Leerlingen_Found_For_LesInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Les_Start_Api_Errors_No_Leerlingen_Found_For_LesInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_les_start_api_errors_no_leerlingen_found_for_les(inputs)
});
export { les_start_api_errors_no_leerlingen_found_for_les as "les.start.api_errors.no_leerlingen_found_for_les" }